import { Type } from '@angular/core';
import { FormArray } from '@angular/forms';

export type ComponentCell<C = any> = {
  component: Type<C>;
  data: Partial<C>;
  formControl?: boolean;
  formArray?: FormArray;
};

export interface Column {
  id: string;
  name: string;
  type?: ColumnType;
  columnConfig?: StatusColumTypes;
  mask?: string;
  component?: ComponentCell;
  format?: (row: any) => string;
  options?: any[];
  optionLabel?: string;
  optionValue?: string;
  // Ordenação (server-side): habilita cabeçalho clicável. `sortKey` é a chave
  // lógica emitida no sortChange; quando omitida, usa-se `id`.
  sortable?: boolean;
  sortKey?: string;
}

export enum ColumnType {
  STATUS = 'STATUS',
  CURRENCY = 'CURRENCY',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  MASK = 'MASK',
  NAME = 'NAME',
  SELECT_DATA = 'SELECT_DATA',
  SELECT_EDITABLE = 'SELECT_EDITABLE',
  CPF_CNPJ = 'CPF_CNPJ',
  COMPONENT = 'COMPONENT',
  STATUS_ACTION = 'STATUS_ACTION'
}

export enum Cores {
  REPROVADO = 'red',
  APROVADO = 'green',
  AGUARDANDO = 'orange',
  DEFAULT = 'gray',
}

export interface StatusColumTypes {
  [name: string]: StatusColum;
}
export interface StatusColum {
  color?: string;
  description: string;
  icon?: string;
}

export interface SelectedItem {
  id: any;
  page?: number;
  item?: any;
}